import { render, staticRenderFns } from "./dataFormHospital.vue?vue&type=template&id=17533733&scoped=true"
import script from "./dataFormHospital.vue?vue&type=script&lang=js"
export * from "./dataFormHospital.vue?vue&type=script&lang=js"
import style0 from "./dataFormHospital.vue?vue&type=style&index=0&id=17533733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17533733",
  null
  
)

export default component.exports